import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.object.define-property";
import "core-js/modules/es.object.to-string";
import { __assign, __awaiter, __decorate, __extends, __generator } from "tslib";
import { Vue, Component, Watch } from 'vue-property-decorator';
import { loading, enumData, userPrefPageSize } from '@/decorators';
import EditModal from './editModal.vue';
import MoreWrapperModal from './moreWrapperModal.vue';
import PrintBoxMark from './printBoxMark/index.vue';
import { bulkRequest } from '@/utils/bulkRequest';
import util from '@/utils/util';
import { namespace } from 'vuex-class';
var User = namespace('user');
var printBoxMark = util.mountVueComponent(PrintBoxMark);

var WrapperInboundTabPage = function (_super) {
  __extends(WrapperInboundTabPage, _super);

  function WrapperInboundTabPage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.dataList = [];
    _this.columns = [];
    _this.loadingStatus = false;
    _this.selectedList = [];
    _this.rowSelection = {};
    _this.datetimeDefaultValue = _this.$util.getDefaultTimeCondition();
    _this.addEditVisible = false;
    _this.moreWrapperVisible = false;
    _this.rowData = {};
    _this.inOrderStatusEnum = [];
    _this.packageOptionEnum = [];
    _this.packageCategoryEnum = [];
    _this.wrapperTimeEnum = [];
    _this.packageOrderCodeEnum = [{
      value: 'order_code',
      text: _this.t('包材入库单号')
    }];
    _this.searchData = _this.initSearchData();
    _this.warehouseList = [];
    _this.lastParams = {};
    _this.total = 0;
    return _this;
  }

  Object.defineProperty(WrapperInboundTabPage.prototype, "isProductPrivateWrapper", {
    get: function get() {
      return this.customerInfo.is_product_private_wrapper;
    },
    enumerable: false,
    configurable: true
  });

  WrapperInboundTabPage.prototype.created = function () {
    this.rowSelection = {
      selectedRowKeys: this.selectedList,
      onChange: this.onSelectChange
    };
    this.setColumns();
    this.queryList();
    this.queryWarehouseList();
  };

  WrapperInboundTabPage.prototype.setColumns = function () {
    this.columns = [{
      title: this.t('包材入库单号'),
      dataIndex: 'order_code',
      filterEmpty: true,
      isCopy: true
    }, {
      title: this.t('状态'),
      dataIndex: 'status_text',
      filterEmpty: true
    }, {
      title: this.t('耗材类型'),
      dataIndex: 'consumable_type_text',
      filterEmpty: true,
      scopedSlots: {
        customRender: 'consumable_type_text'
      }
    }, {
      title: this.t('预报包材信息'),
      dataIndex: 'details',
      scopedSlots: {
        customRender: 'details'
      }
    }, {
      title: this.t('收货信息'),
      dataIndex: 'receive_details',
      scopedSlots: {
        customRender: 'receive_details'
      }
    }, {
      title: this.t('入库仓库（区域）'),
      name: 'warehouse_code',
      scopedSlots: {
        customRender: 'warehouse_code'
      }
    }, {
      title: this.t('备注信息'),
      dataIndex: 'remark',
      filterEmpty: true
    }, {
      title: this.t('时间'),
      dataIndex: 'time',
      width: 200,
      scopedSlots: {
        customRender: 'time'
      }
    }, {
      width: 170,
      title: this.t('操作'),
      name: 'operation',
      fixed: 'right',
      scopedSlots: {
        customRender: 'operation'
      }
    }];
  };

  WrapperInboundTabPage.prototype.onDatetimeDefaultValueChange = function (arr) {
    if (arr.length) {
      this.searchData.time_start = this.$util.formatDateTime(arr[0]);
      this.searchData.time_end = this.$util.formatDateTime(arr[1]);
    } else {
      this.searchData.time_start = '';
      this.searchData.time_end = '';
    }
  };

  WrapperInboundTabPage.prototype.initSearchData = function () {
    return {
      status: undefined,
      order_code: '',
      package_option: 'package_code',
      package_option_value: '',
      package_type: undefined,
      package_value: '',
      package_category: undefined,
      time_type: this.$enum.warehouse.InnboundWrapperTimeType.CREATE_TIME,
      time_start: '',
      time_end: '',
      warehouse_code: undefined,
      page_index: 1,
      page_size: 20
    };
  };

  WrapperInboundTabPage.prototype.onSelectChange = function (selectedRowKeys) {
    this.selectedList = this.rowSelection.selectedRowKeys = selectedRowKeys;
  };

  WrapperInboundTabPage.prototype.queryList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var data, list, total;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.lastParams = this.$util.deepCopy(this.searchData);
            this.total = null;
            return [4, this.$api.wrapper.queryWrapperInboundList(this.searchData)];

          case 1:
            data = _a.sent().data;
            list = data.list, total = data.total;
            this.dataList = list;
            this.total = total;
            return [2];
        }
      });
    });
  };

  WrapperInboundTabPage.prototype.handlePageChange = function (val) {
    this.searchData.page_index = val;
    this.selectedList.length = 0;
    this.queryList();
  };

  WrapperInboundTabPage.prototype.handleTabChange = function (key) {
    this.initPage();
    this.queryList();
  };

  WrapperInboundTabPage.prototype.initPage = function () {
    this.selectedList.length = 0;
    this.searchData.page_index = 1;
  };

  WrapperInboundTabPage.prototype.handleSearch = function () {
    this.initPage();
    this.queryList();
  };

  WrapperInboundTabPage.prototype.handleReset = function () {
    var _this = this;

    this.searchData = this.initSearchData();
    this.datetimeDefaultValue = this.$util.getDefaultTimeCondition();
    this.$nextTick(function () {
      return _this.queryList();
    });
  };

  WrapperInboundTabPage.prototype.handleExport = function (isAll) {
    return __awaiter(this, void 0, Promise, function () {
      var postData, _a, code, data, message;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            postData = {};

            if (isAll) {
              postData = __assign({}, this.lastParams);
              delete postData.page_index;
              delete postData.page_size;
            } else {
              if (!this.selectedList.length) {
                return [2, this.$message.warn(this.t('common', this.$config.exportSelectedEmptyTip))];
              }

              postData = {
                order_code_list: this.selectedList
              };
            }

            return [4, this.$api.wrapper.excelWrapperInbound(postData)];

          case 1:
            _a = _b.sent(), code = _a.code, data = _a.data, message = _a.message;

            if (code === 0) {
              this.$util.exportExcel(data);
            } else {
              this.$message.error(message);
            }

            return [2];
        }
      });
    });
  };

  WrapperInboundTabPage.prototype.handleAdd = function () {
    this.rowData.title = this.t('新增包材入库');
    this.rowData.data = null;
    this.addEditVisible = true;
  };

  WrapperInboundTabPage.prototype.handleEdit = function (record) {
    this.rowData.title = this.t('编辑包材入库');
    this.rowData.data = record;
    this.addEditVisible = true;
  };

  WrapperInboundTabPage.prototype.handlePrint = function (data) {
    printBoxMark({
      parent: this,
      propsData: {
        data: data,
        onSuccess: function onSuccess() {}
      }
    });
  };

  WrapperInboundTabPage.prototype.handleDiscard = function (orderCode) {
    var _this = this;

    var modal = this.$confirm({
      title: this.t('废弃提示'),
      content: this.t('请确认是否废弃该记录？'),
      onOk: function onOk() {
        return __awaiter(_this, void 0, Promise, function () {
          var _a, code, message, error_1;

          return __generator(this, function (_b) {
            switch (_b.label) {
              case 0:
                _b.trys.push([0, 2,, 3]);

                return [4, this.$api.wrapper.discardWrapperInbound({
                  order_code: orderCode
                })];

              case 1:
                _a = _b.sent(), code = _a.code, message = _a.message;

                if (code === 0) {
                  this.$message.success(this.t('操作成功'));
                  this.queryList();
                  this.selectedList.length = 0;
                } else {
                  this.$message.error(message);
                }

                return [3, 3];

              case 2:
                error_1 = _b.sent();
                modal.destroy();
                return [3, 3];

              case 3:
                return [2];
            }
          });
        });
      }
    });
  };

  WrapperInboundTabPage.prototype.handleDelete = function (orderCode) {
    var _this = this;

    var modal = this.$confirm({
      title: this.t('删除提示'),
      content: this.t('请确认是否删除该记录？'),
      onOk: function onOk() {
        return __awaiter(_this, void 0, Promise, function () {
          var _a, code, message, error_2;

          return __generator(this, function (_b) {
            switch (_b.label) {
              case 0:
                _b.trys.push([0, 2,, 3]);

                return [4, this.$api.wrapper.deleteWrapperInbound({
                  order_code: orderCode
                })];

              case 1:
                _a = _b.sent(), code = _a.code, message = _a.message;

                if (code === 0) {
                  this.$message.success(this.t('操作成功'));
                  this.queryList();
                  this.selectedList.length = 0;
                } else {
                  this.$message.error(message);
                }

                return [3, 3];

              case 2:
                error_2 = _b.sent();
                modal.destroy();
                return [3, 3];

              case 3:
                return [2];
            }
          });
        });
      }
    });
  };

  WrapperInboundTabPage.prototype.handleSubmitBulk = function () {
    if (!this.selectedList.length) {
      this.$message.warn(this.t('请选择需要提交的数据'));
      return;
    }

    this.submitOrderAudit(this.selectedList);
  };

  WrapperInboundTabPage.prototype.submitOrderAudit = function (data) {
    var _this = this;

    this.$confirm({
      title: this.tc('温馨提示'),
      content: this.t('请确认是否提交？'),
      onOk: function onOk() {
        bulkRequest({
          title: _this.t('提交预报单'),
          titleWidth: 340,
          data: data,
          request: function request(item) {
            return __awaiter(_this, void 0, Promise, function () {
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    return [4, this.$api.wrapper.submitWrapperInbound({
                      order_code: item
                    }, {
                      showError: false
                    })];

                  case 1:
                    return [2, _a.sent()];
                }
              });
            });
          },
          content: function content(item) {
            return _this.tc('预报单号') + _this.tc('：') + item;
          },
          onCancel: function onCancel() {
            _this.queryList();
          }
        });
      }
    });
  };

  WrapperInboundTabPage.prototype.handleMore = function (data, title) {
    this.rowData.title = title;
    this.rowData.data = data;
    this.moreWrapperVisible = true;
  };

  WrapperInboundTabPage.prototype.queryWarehouseList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var _a, data;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            return [4, this.$api.common.queryAllWarehouseList()];

          case 1:
            _a = _b.sent().data, data = _a === void 0 ? [] : _a;
            this.warehouseList = data;
            return [2];
        }
      });
    });
  };

  __decorate([enumData('Wrapper/InOrderStatusEnum')], WrapperInboundTabPage.prototype, "inOrderStatusEnum", void 0);

  __decorate([enumData('Wrapper/PackageOptionEnum')], WrapperInboundTabPage.prototype, "packageOptionEnum", void 0);

  __decorate([enumData('Wrapper/PackageCategoryEnum')], WrapperInboundTabPage.prototype, "packageCategoryEnum", void 0);

  __decorate([enumData('Wrapper/WrapperTimeEnum')], WrapperInboundTabPage.prototype, "wrapperTimeEnum", void 0);

  __decorate([User.State('customerInfo')], WrapperInboundTabPage.prototype, "customerInfo", void 0);

  __decorate([Watch('datetimeDefaultValue', {
    immediate: true
  })], WrapperInboundTabPage.prototype, "onDatetimeDefaultValueChange", null);

  __decorate([userPrefPageSize('wrapperInboundList')], WrapperInboundTabPage.prototype, "initSearchData", null);

  __decorate([loading('loadingStatus')], WrapperInboundTabPage.prototype, "queryList", null);

  WrapperInboundTabPage = __decorate([Component({
    components: {
      EditModal: EditModal,
      MoreWrapperModal: MoreWrapperModal
    }
  })], WrapperInboundTabPage);
  return WrapperInboundTabPage;
}(Vue);

export default WrapperInboundTabPage;